import { useBreakpoints } from "@3gaam/shared/hooks/useBreakpoints";
import { useEffect, useState } from "react";

interface Props {
  preTitle?: string;
  preDescription?: string;
  startDateInUtc: string;
  preLink?: string;
  hasPreload: boolean,
  hideCountDown: boolean,
  title: string;
  description: string;
  targetDateInUtc: string;
  backgroundColor: string;
  link?: string;
  icon: React.ReactNode;
}

type Countdown = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};
export const Promotion = ({
  backgroundColor,
  description,
  icon,
  title,
  hasPreload,
  hideCountDown,
  link,
  targetDateInUtc,
  preDescription,
  preTitle,
  preLink,
  startDateInUtc,
}: Props) => {
  let breakpointState = useBreakpoints("lg");
  let lowerMd = breakpointState === "lower";

  const targetDate = new Date(targetDateInUtc);
  const startDate = new Date(startDateInUtc);
  const now = new Date();

  const [countdown, setCountdown] = useState<Countdown | null>(null);
  const [dateWeUse, setDateWeUse] = useState<"start" | "target">("target");
  const [showBanner, setShowBanner] = useState(
    (hasPreload || now.getTime() > startDate.getTime()) && (now.getTime() < targetDate.getTime()),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      let targetDate = new Date(targetDateInUtc);
      let startDate = new Date(startDateInUtc);
      const now = new Date();
      let shouldUseStartDate = now.getTime() < startDate.getTime();
      let dateToUse = shouldUseStartDate ? startDate : targetDate;
      setDateWeUse(shouldUseStartDate ? "start" : "target");
      setShowBanner((hasPreload || now.getTime() > startDate.getTime()) && (now.getTime() < targetDate.getTime()));

      const diff = dateToUse.getTime() - now.getTime();
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),);
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setCountdown({ days, hours, minutes, seconds });

      if (diff <= 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [startDateInUtc, targetDateInUtc, hasPreload]);

  if (!showBanner) return null;

  return (
    <div className="d-flex w-100"
      style={{
        height: 64,
        backgroundColor,
        paddingRight: lowerMd ? "0.75rem" : "8rem",
        paddingLeft: lowerMd ? "0.75rem" : "8rem",
      }}
    >
      <a
        href={dateWeUse === "start" ? preLink : link}
        className="d-flex flex-row align-items-center justify-content-between w-100"
        style={{
          maxWidth: hideCountDown ? lowerMd ? "100%" : "75%" : "100%",
          margin: hideCountDown ? "0 auto" : "unset"
        }}
      >
        <div className="d-flex flex-row align-items-center"
          style={{
            margin: hideCountDown && lowerMd ? "0 auto" : "unset"
          }}>
          <div style={{ width: 48, height: 48, position: "relative" }}>
            {icon}
          </div>
          <div
            style={{
              marginRight: lowerMd ? "0.5rem" : "1rem",
            }}
          >
            <span
              style={{
                color: "#fff",
                fontSize: lowerMd ? 14 : 18,
                fontWeight: "bold",
              }}
            >
              {dateWeUse === "start" && preTitle ? preTitle : title}
            </span>
            {lowerMd ? (
              <span
                className="d-flex "
                style={{ color: "#fff", fontSize: 12, marginTop: "0.25rem" }}
              >
                {dateWeUse === "start" && preDescription
                  ? preDescription
                  : description}
              </span>
            ) : null}
          </div>
        </div>
        {hideCountDown ? null :
          (
            <span className="d-flex flex-row"
              style={{ color: "#fff", fontSize: 12, marginTop: "0.25rem" }}
            >
              <CountdownSection title="ثانیه" value={countdown?.seconds} />
              <CountdownSeparator />
              <CountdownSection title="دقیقه" value={countdown?.minutes} />
              <CountdownSeparator />
              <CountdownSection title="ساعت" value={countdown?.hours} />
              <CountdownSeparator />
              <CountdownSection title="روز" value={countdown?.days} />
            </span>
          )
        }
        {lowerMd ? null : (
          <span className="d-flex" style={{ color: "#fff", fontSize: 18 }}>
            {dateWeUse === "start" && preDescription
              ? preDescription
              : description}
          </span>
        )}
      </a>
    </div>
  );
};

const CountdownSection = ({
  title,
  value,
}: {
  value: number | undefined;
  title: string;
}) => {
  let breakpointState = useBreakpoints("lg");
  let lowerMd = breakpointState === "lower";

  return (
    <div className="d-flex flex-column align-items-center">
      <span
        style={{
          color: "#fff",
          fontSize: lowerMd ? 14 : 26,
          fontWeight: "bold",
          width: lowerMd ? 20 : 35,
          textAlign: "center",
        }}
      >
        {`${value || "00"}`.padStart(2, "0")}
      </span>
      <span
        style={{
          color: "#fff",
          fontSize: lowerMd ? 8 : 12,
          marginTop: lowerMd ? 0 : -4,
        }}
      >
        {title}
      </span>
    </div>
  );
};
const CountdownSeparator = () => {
  let breakpointState = useBreakpoints("lg");
  let lowerMd = breakpointState === "lower";
  return (
    <span
      style={{
        color: "rgba(255, 255, 255, 0.67)",
        fontSize: lowerMd ? 12 : 20,
        fontWeight: "bold",
        lineHeight: lowerMd ? "19px" : "31px",
        paddingRight: lowerMd ? 2 : 8,
        paddingLeft: lowerMd ? 2 : 8,
      }}
    >
      :
    </span>
  );
};
